import React from 'react';

import { EI_FEATURES } from '../../../constants/pricing/planFeatures';

function withEI(Component) {
  const WithEI = (props) => (
    <Component category="e" features={EI_FEATURES} {...props} />
  );
  WithEI.displayName = `withEI(${
    Component.displayName || Component.name || 'Component'
  })`;
  return WithEI;
}

export default withEI;
